export default "__VITE_ASSET__BYkwTvoj__"